import React, { createContext, useState, useEffect } from "react";
import {
  getToken,
  redirectToErrorPage,
  isObject,
  isPaymentSuccessRoute,
  getCurrentPageUrl,
  storePaymentQueryParams
} from "./../utils/helpers";
import { binMessageDefaultError } from "../utils/constants";
import { getUrlParams } from "@lux/helpers";
import { usePubSub } from "@wec-core/dt-module-communication";
import { useOAuth } from "./../utils/constants";
export const PaymentContext = createContext();

export const PaymentProvider = ({ children, location }) => {
  const [summaryEmail, setSummaryEmail] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState({});
  const [paymentMethod, setPaymentMethod] = useState("");
  const [oauthToken, setOauthToken] = useState(null);
  const [uobCardInfo, setUobCardInfo] = useState({
    displayUobCard: false,
    uobCardBinRanges: [],
    binMessage: ""
  });

  const [manageCardsInfo, setManageCardsInfo] = useState({
    txnType: "payment",
    operationsAllowed: [],
    manageCardsInstrumentInfo: []
  });

  const { publish } = usePubSub("topicB");

  useEffect(() => {
    async function invokeOauthToken() {
      const pageUrl = getCurrentPageUrl();
      let queryParams = pageUrl
        ? getUrlParams(pageUrl)
        : { paymentToken: null, correlationId: null };
      let paymentQP = sessionStorage.getItem("paymentQP");
      if (storePaymentQueryParams(paymentQP, queryParams)) {
        paymentQP = sessionStorage.getItem("paymentQP");
        publish(`debug sdk log invokeOauthToken paymentQP ${paymentQP}`);
      }
      if (!isPaymentSuccessRoute() && paymentQP) {
        queryParams = getUrlParams(paymentQP);
      }

      // Check if OAuth mode is enabled
      if (!useOAuth) {
        publish("debug sdk WAF mode enabled - skipping OAuth token fetch");
        /* Set to avoid all the pitfalls.
           This will be avoided if OAuth mode is enabled.
        */
        setOauthToken("wafmode");
        return;
      }

      if (isObject(queryParams) && Object.keys(queryParams).length) {
        const { paymentToken, correlationId } = queryParams;
        if (paymentToken && correlationId) {
          try {
            const token = await getToken({ paymentToken, correlationId });
            if (token) {
              publish(
                `debug sdk log invokeOauthToken successful token ${token}`
              );
              setOauthToken(token);
            }
          } catch (e) {
            console.log("Error in fetching token", e);
            publish("debug sdk log invokeOauthToken error in fetching token");
            redirectToErrorPage();
            sessionStorage.removeItem("paymentQP");
          }
        }
      }
    }

    /* istanbul ignore next */
    if (!oauthToken) invokeOauthToken();
  }, []);

  useEffect(() => {
    const storedUobCardInfo = sessionStorage.getItem("uobCardInfo");
    if (storedUobCardInfo) {
      // If the value exists in sessionStorage, read and set it
      const parsedUobCardInfo = JSON.parse(storedUobCardInfo);
      setUobCardInfo(parsedUobCardInfo);
    }
  }, []);

  const saveSummaryEmail = (email) => {
    setSummaryEmail(email);
  };

  const savePaymentInfo = (payment) => {
    setPaymentInfo(payment);
    sessionStorage.setItem("successRedirectUrl", payment.successRedirectUrl);
    sessionStorage.setItem("failureRedirectUrl", payment.failureRedirectUrl);
  };

  const savePaymentMethod = (method) => {
    setPaymentMethod(method);
    sessionStorage.setItem("paymentType", method);
  };

  const saveUobCardInfo = ({
    displayUobCard = false,
    uobCardBinRanges = [],
    binMessage = binMessageDefaultError
  }) => {
    // If the value does not exist, set it in state and sessionStorage
    const newUobCardInfo = { displayUobCard, uobCardBinRanges, binMessage };
    setUobCardInfo(newUobCardInfo);
    sessionStorage.setItem("uobCardInfo", JSON.stringify(newUobCardInfo));
  };

  return (
    <PaymentContext.Provider
      value={{
        summaryEmail,
        saveSummaryEmail,
        paymentInfo,
        savePaymentInfo,
        paymentMethod,
        savePaymentMethod,
        manageCardsInfo,
        setManageCardsInfo,
        oauthToken,
        setOauthToken,
        saveUobCardInfo,
        uobCardInfo
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export default PaymentProvider;
